import type { SVGProps } from "react";
// generated from ArrowRight.svg — do not edit manually
// prettier-ignore
export default function ArrowRight(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
  <path d="M13 5L20 12M20 12L13 19M20 12L4 12" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
